import { useNavigate } from "react-router-dom";
import { useSuccessToast } from "../../toast/useSuccessToast";
import { customAuthAxios } from "../../../utils/customAuthAxios";


export const useEditRouletteCouponAndSegment = (couponId?: string, segmentId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();
  const onSubmit = async (data: any) => {
    try {
      const uploadData = new FormData();
      const fields = ["title", "explanation", "notes", "expiration_date"];
      fields.forEach(field => uploadData.append(field, data[field]));
      if (data.img && data.img[0]) {
        uploadData.append("img", data.img[0]);
      }
      await customAuthAxios.put(`games/roulette/coupons/${couponId}/`, uploadData)
      await customAuthAxios.put(`games/roulette/coupon/segments/${segmentId}/`, {segment_count: data.segment_count})
      showToast('編集が完了しました');
      navigate(-1);
    } catch (error: any) {
    }
  };
  return onSubmit;
};